/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import IconDropdown from 'views/atoms/dropdown/IconDropdown';

import { getUser } from 'store/auth/selectors';
import 'views/molecules/notification/notifications.scss';
import actions from 'store/notifications/actions';
import { commonSelectors } from 'store/common';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { notificationsSelectors } from 'store/notifications';
import {
  getGMT9ISOString,
  handleHoverNotificationIcon,
  handleStorageTrackingData,
} from 'domain/notifications/Services';
import NotificationItem from './NotificationItem';

/**
 * Component to show notifications for Ebis Front Page
 *
 * notificationList: array of data
 * updateNotification: function to update read notification
 */
const Notification = ({
  notificationList,
  // eslint-disable-next-line no-unused-vars
  updateNotification,
  addToNewsModal,
  newsModalState,
}) => {
  const dispatch = useDispatch();

  const { tooltipState, tutorialModalStatus, userId, account } = {
    tooltipState: useSelector(notificationsSelectors.getTooltipState),
    tutorialModalStatus: useSelector(commonSelectors.getTutorialModalStatus),
    ...useSelector(getUser, shallowEqual),
  };

  // Load tracking notifications from localStorage
  const trackingNotificationsRaw = localStorage.getItem(
    `tracking_notifications.${account.accountId}.${userId}`
  );
  
  const trackingNotifications = trackingNotificationsRaw
    ? JSON.parse(trackingNotificationsRaw)
    : [];

  // Ref to always have latest tooltipState in event handlers
  const tooltipStateRef = useRef(tooltipState);
  tooltipStateRef.current = tooltipState;
  const dropdownRef = useRef();

  const newNotifications = notificationList.filter((item) => !item.read);

  const [isActiveDropdown, toggleActive] = useState(false);
  // State for current open item
  // eslint-disable-next-line no-unused-vars
  const [currentOpenId, changeOpenId] = useState(null);

  // INFO: change request to display in modal
  // const handleOnClickNews = useCallback(
  //   (id) => {
  //     changeOpenId((currentid) =>
  //       id !== currentid ? changeOpenId(id) : changeOpenId(null)
  //     );

  //     // If not read -> click -> update to read
  //     if (id !== null && newNotifications.includes(id)) updateNotification(id);
  //   },
  //   [newNotifications, updateNotification]
  // );

  // INFO: change request to display in modal
  // When close Notification, collapse content with currentOpenId
  // useEffect(() => {
  //   if (isActiveDropdown === false) changeOpenId(null);
  // }, [isActiveDropdown]);

  // Hack: don't close dropdown when modal is still open
  const [cancelCloseModalEvent, toggleCloseModalEvent] = useState(false);

  useEffect(() => {
    if (cancelCloseModalEvent !== newsModalState)
      toggleCloseModalEvent(newsModalState);
  }, [newsModalState, cancelCloseModalEvent]);

  const handleSavetoLocal = (dataStorage) => {
    if (Array.isArray(trackingNotifications)) {
      trackingNotifications.push(dataStorage);
      localStorage.setItem(
        `tracking_notifications.${account.accountId}.${userId}`,
        JSON.stringify(trackingNotifications)
      );
    }
  };

  // Handle dropdown toggle and track tooltip click if type is 'auto'
  const handleToggle = (isShow) => {
    if (cancelCloseModalEvent) return;
    // tracking user click on icon when tooltip type is 'auto'
    if (tooltipState.isShow && tooltipState.type === 'auto') {
      const dataStorage = handleStorageTrackingData({
        action: 'tooltip_click',
        accountId: account.accountId,
        userId,
        date: getGMT9ISOString(),
      });
      handleSavetoLocal(dataStorage);
    }
    toggleActive(isShow);
  };

  const handleOnClickNews = useCallback(
    (id) => {
      addToNewsModal(id);
    },
    [addToNewsModal]
  );

  const getNotificationCount = useCallback(() => {
    if (newNotifications.length > 9)
      return (
        <>
          9<i className="fal fa-plus" style={{ fontSize: 8 }} />
        </>
      );
    return newNotifications.length;
  }, [newNotifications]);

  // Hide tooltip when clicking anywhere on the window
  useEffect(() => {
    const handleClick = () => {
      if (tooltipStateRef.current?.isShow) {
        dispatch(
          actions.toggleTooltip({ ...tooltipStateRef.current, isShow: false })
        );
      }
    };
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, []);

  // Show tooltip if tutorial modal is not open and tooltip has a message
  useEffect(() => {
    if (!tutorialModalStatus && tooltipState?.message.length > 0) {
      dispatch(actions.toggleTooltip({ ...tooltipState, isShow: true }));
    }
  }, [tutorialModalStatus, dispatch]);

  // Track tooltip show event with type 'auto'
  useEffect(() => {
    if (tooltipState?.isShow && tooltipState?.type === 'auto') {
      const dataStorage = handleStorageTrackingData({
        action: 'tooltip_display',
        accountId: account.accountId,
        userId,
        date: getGMT9ISOString(),
      });
      handleSavetoLocal(dataStorage);
    }
  }, [tooltipState, dispatch]);

  return (
    <Dropdown
      bsPrefix="dropdown"
      className="navbar-notification"
      show={isActiveDropdown}
      onToggle={(isShow) => handleToggle(isShow)}
      ref={dropdownRef}
    >
      <Dropdown.Toggle as={IconDropdown}>
        <OverlayTrigger
          placement="bottom"
          container={dropdownRef?.current}
          overlay={
            <Tooltip className="tooltip-notification">
              {tooltipState?.message}
            </Tooltip>
          }
          show={tooltipState?.isShow && !tutorialModalStatus}
        >
          <div
            className="d-flex justify-content-center icon-notification-wrapper"
            onMouseEnter={() => {
              if (!tooltipState?.isShow) {
                handleHoverNotificationIcon(newNotifications, dispatch);
              }
            }}
            onMouseLeave={() => {
              dispatch(
                actions.toggleTooltip({ ...tooltipState, isShow: false })
              );
            }}
          >
            {newNotifications.length > 0 && (
              <span className="icon-notification-number d-flex align-items-center justify-content-center">
                {getNotificationCount()}
              </span>
            )}
            <span className="icon-svg icon-notification icon-svg__w36 " />
          </div>
        </OverlayTrigger>
      </Dropdown.Toggle>
      <Dropdown.Menu
        alignRight="true"
        className="dropdown-menu-shadow notification__drawer navbar--border-top-red"
      >
        <div className="d-flex justify-content-center flex-column">
          <div className="notification__header">お知らせ</div>
          <div className="notification__content-box">
            {
              // Only load contents when Notification is open
              isActiveDropdown &&
                Object.keys(notificationList).length !== 0 &&
                notificationList.map((notification) => (
                  <NotificationItem
                    handleOnClickNews={handleOnClickNews}
                    data={notification}
                    isExpanded={notification.id === currentOpenId}
                    isNew={newNotifications.some(
                      (item) => item.id === notification.id
                    )}
                  />
                ))
            }
          </div>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

Notification.defaultProps = {
  updateNotification: () => {},
  addToNewsModal: () => {},
};

Notification.propTypes = {
  notificationList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      date_from: PropTypes.string.isRequired,
      // eslint-disable-next-line react/forbid-prop-types
      detail: PropTypes.any.isRequired,
      target_type: PropTypes.number.isRequired,
      display_type: PropTypes.number.isRequired,
      priority: PropTypes.number.isRequired,
      read: PropTypes.bool.isRequired,
    })
  ).isRequired,
  updateNotification: PropTypes.func,
  addToNewsModal: PropTypes.func,
  newsModalState: PropTypes.bool.isRequired,
};

export default React.memo(Notification);
